import React from 'react';
import { useNavigate } from 'react-router-dom';

const FooterColumn = ({ title, links, navigate }) => (
  <div>
    <h4 className="font-semibold mb-3 tracking-wide text-lg text-gray-900">
      {title}
    </h4>
    <ul className="space-y-1">
      {links.map(link => (
        <li key={link.label}>
          <a
            href={link.path}
            onClick={(e) => {
              e.preventDefault();
              navigate(link.path);
            }}
            className="text-gray-600 hover:text-gray-900 transition text-xs"
          >
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default function FooterSection() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'AI Mock Interview India', path: '/ai-mock-interview-india' }, // 🔥 SEO BOOST
      { label: 'Pricing', path: '/pricing-plans' },
      { label: 'Blog', path: '/blog-content-hub' },
      { label: 'Resume Builder', path: '/resume-builder' }
    ],
    company: [
      { label: 'About Us', path: '/about-platform' }
    ],
    resources: [
      { label: 'Help Center', path: '/blog-content-hub' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '/about-platform' }
    ]
  };

  return (
    <footer className="bg-gradient-to-b from-gray-100 to-gray-200 text-gray-800 border-t shadow-elevation-1">

      {/* HEADER STRIP (your original design) */}
      <div className="max-w-7xl mx-auto px-6 py-0 -mt-8 -mb-8">
        <div className="flex flex-col md:flex-row items-center justify-between">

          {/* LOGO */}
          <div className="flex items-center flex-grow">
            <img
              src="/assets/images/Logo_Botervue.png"
              alt="Botervue AI Mock Interview India"
              className="w-[160px] object-contain mr-2"
            />

            <p className="text-gray-600 text-sm whitespace-nowrap">
              ATS-optimized resumes & interview preparation that gets you hired faster.
            </p>
          </div>

          {/* CTA */}
          <a
            href="/resume-builder"
            onClick={(e) => {
              e.preventDefault();
              navigate('/resume-builder');
            }}
            className="border border-gray-400 px-6 py-2 rounded-lg hover:bg-gray-200 transition font-medium text-sm hidden lg:block"
          >
            🚀 Explore Resume Builder
          </a>

        </div>
      </div>

      {/* LINKS */}
      <div className="max-w-7xl mx-auto px-6 py-8 border-t border-gray-300">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          <FooterColumn title="Product" links={footerLinks.product} navigate={navigate} />
          <FooterColumn title="Company" links={footerLinks.company} navigate={navigate} />
          <FooterColumn title="Resources" links={footerLinks.resources} navigate={navigate} />
          <FooterColumn title="Legal" links={footerLinks.legal} navigate={navigate} />
        </div>
      </div>

      {/* BOTTOM */}
      <div className="border-t border-gray-300 px-6 py-4 text-xs">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-3 text-gray-600">
          <span>© {currentYear} Botervue. All rights reserved.</span>
          <div className="flex gap-3">
            <span>🔒 SSL Secured</span>
            <span>🛡 GDPR Compliant</span>
          </div>
        </div>
      </div>

    </footer>
  );
}